module.exports = __webpack_public_path__ + "media/images/partners/vash-dosug-3ac90c4412c35e34ecb88bae145ecba9.png";